import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Building2, Calendar, CheckCircle, User } from "lucide-react";
export default function ArticleHeader() {
  const metaData = [{
    id: "party",
    label: "Pihak Pemberi Klarifikasi",
    value: "Kementerian Keuangan RI",
    icon: Building2,
    isAvatar: true,
    avatarImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kemenkeu_logo.png",
    fallback: "KK"
  }, {
    id: "author",
    label: "Penulis",
    value: "Tim Jurnalis Fakta",
    icon: User,
    isAvatar: false
  }, {
    id: "date",
    label: "Tanggal Publikasi",
    value: "24 Oktober 2023",
    icon: Calendar,
    isAvatar: false
  }, {
    id: "status",
    label: "Status Verifikasi",
    value: "Terverifikasi Resmi",
    icon: CheckCircle,
    isAvatar: false,
    highlight: true
  }];
  return <section id="article-header" className="bg-background w-full py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 max-w-5xl">
        
        {}
        <div className="mb-8">
          <Breadcrumb>
            <BreadcrumbList className="text-xs sm:text-sm font-sans text-muted-foreground gap-1 sm:gap-2.5">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="#">Beranda</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="#">Klarifikasi</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-muted-foreground">Detail Artikel</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <div className="mb-6">
          <Badge variant="outline" className="text-xs sm:text-sm md:text-base font-bold text-primary border-primary/30 bg-primary/5 px-3 md:px-4 py-1 rounded-full">
            Klarifikasi Resmi
          </Badge>
        </div>

        {}
        <h1 className="text-3xl sm:text-4xl md:text-[44px] font-bold text-foreground leading-[1.15] tracking-tight mb-6">
          Pemerintah Bantah Isu Kenaikan Pajak Kendaraan Bermotor Sebesar 50% di Tahun 2024
        </h1>

        {}
        <p className="text-lg sm:text-xl md:text-[20px] text-secondary font-sans leading-relaxed mb-10">
          Beredar kabar di media sosial mengenai rencana kenaikan pajak kendaraan bermotor yang drastis. Kementerian Keuangan memberikan pernyataan resmi untuk meluruskan informasi yang beredar di masyarakat agar tidak menimbulkan kepanikan.
        </p>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-6 py-8 border-y border-border mb-10">
          {metaData.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col gap-2">
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {item.label}
              </span>
              <div className="flex items-center gap-2.5">
                {item.isAvatar ? <SafeHydrate><Avatar className="size-6 border border-border">
                    <AvatarImage src={item.avatarImg} alt={item.value} />
                    <AvatarFallback className="text-[10px] bg-muted text-muted-foreground">
                      {item.fallback}
                    </AvatarFallback>
                  </Avatar></SafeHydrate> : <item.icon className={`size-4 ${item.highlight ? 'text-primary' : 'text-muted-foreground'}`} />}
                <span className={`text-sm font-medium ${item.highlight ? 'text-primary' : 'text-foreground'}`}>
                  {item.value}
                </span>
              </div>
            </div>)}
        </div>

        {}
        <div className="bg-muted/50 border border-border border-l-4 border-l-primary p-6 sm:p-8 lg:p-10 rounded-r-lg mx-auto">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left">
            <div className="bg-background p-3 rounded-full shadow-sm shrink-0">
              <CheckCircle className="size-6 text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-foreground mb-2">Kesimpulan Verifikasi</h3>
              <p className="text-base text-muted-foreground leading-relaxed">
                Berdasarkan hasil penelusuran dan konfirmasi langsung dengan pihak terkait, informasi mengenai kenaikan pajak kendaraan bermotor sebesar 50% adalah <strong className="text-foreground font-bold">TIDAK BENAR (HOAKS)</strong>. Kebijakan pajak tetap mengacu pada peraturan daerah yang berlaku saat ini tanpa ada kenaikan drastis.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}